export const useMfaRefresh = ({ token, currentUserId, usersPostRequest, setIsTokenExpired }) => {
  const handleMFARefresh = async () => {
    document.querySelector("body").style.cursor = "progress";

    const obj = { userId: currentUserId };
    const response = await usersPostRequest(token, `/api/MFArefresh`, obj);

    if (response === "Token is expired, login again") {
      setIsTokenExpired(true);
    } else if (response === "MFA refreshed") {
      alert("MFA has been disabled successfully!");
    } else if (response === "MFA not refreshed") {
      alert("Failed to disable MFA.");
    } else {
      alert("Something went wrong.");
    }

    document.querySelector("body").style.cursor = "default";
  };

  return { handleMFARefresh };
};
